<template>
  <div class="home">
    <div class="modalVideoUrl" v-if="modalVideoUrl" @click="modalVideoUrl = null">
      <div class="video">
        <button type="button" @click="modalVideoUrl = null">
          <img src="@/assets/images/btn-close.png" />
        </button>

        <video autoplay loop="" playsinline="" v-if="modalVideoUrl.indexOf('https') == -1">
          <source :src="require(`@/assets/videos/${modalVideoUrl}`)" />
        </video>

        <iframe v-else :src="modalVideoUrl + '&autoplay=1'" title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </div>
    </div>

    <div class="row">
      <Slider class="col-12 banner">
        <div class="item">
          <div class="banner-content">
            <div class="banner-text">
              <h1>En Unipar, nuestros colaboradores son los principales protagonistas!</h1>

              <router-link to="/vagas/375953-trabaje-con-nosotros/inscricao"
                class="btn btn-lg btn-outline-color-1 rounded-pill">
                INSCRIBITE
              </router-link>
            </div>

            <img src="@/assets/images/banner-1.png" />
          </div>
        </div>
        <div class="item">
          <div class="banner-content">
            <div class="banner-text">
              <h1>Juntos hacemos que la química suceda de manera responsable y sostenible</h1>

              <router-link to="/vagas/375953-trabaje-con-nosotros/inscricao"
                class="btn btn-lg btn-outline-color-1 rounded-pill">
                INSCRIBITE
              </router-link>
            </div>

            <img src="@/assets/images/banner-2.jpeg" />
          </div>
        </div>
        <div class="item">
          <div class="banner-content">
            <div class="banner-text">
              <h1>Compromiso, dedicación, unidad. Vení y sé parte del #TeamUnipar</h1>

              <router-link to="/vagas/375953-trabaje-con-nosotros/inscricao"
                class="btn btn-lg btn-outline-color-1 rounded-pill">
                INSCRIBITE
              </router-link>
            </div>

            <img src="@/assets/images/banner-3.png" />
          </div>
        </div>
      </Slider>
    </div>

    <div class="row pt-5 mt-5" id="faca-parte">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-1 text-center mb-2">¡Unite al Grupo Unipar!</span>
        <h1 class="text-color-2 text-center pb-5">Unipar, hace que la química suceda.</h1>

        <div class="video-thumb"
          @click="modalVideoUrl = 'https://www.youtube.com/embed/jWhuqFQtoC8?si=n8BnKAQ1a20_LMGr'">
          <img src="@/assets/images/thumb-video-1.png" />
          <img src="@/assets/images/play.png" class="play">
        </div>

        <hr class="mb-0 mt-5" />
      </div>
    </div>


    <div class="row pt-5 mt-5 pb-5" id="a-unipar">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-1 text-center mb-2">#SUMATEAUNIPAR</span>
        <h1 class="text-color-2 text-center pb-3">UNIPAR</h1>
        <p class="text-center">Somos líderes en la producción de cloro y soda cáustica en América del Sur y estamos
          entre los mayores productores de PVC, insumos que forman la base de todas las industrias. Generamos mayor
          calidad, seguridad y salud para hacer tu vida cada día mejor.</p>
      </div>
    </div>

    <div class="row mt-5" id="trabalhe-conosco">
      <div class="col-12 col-md-10 mx-auto">
        <div class="row align-items-center">
          <div class="col-12 col-md-5">
            <img src="@/assets/images/img-trabalhe-conosco.jpeg" style="height: 100%; object-fit: cover;" />
          </div>
          <div class="col-12 col-md-7 p-5">
            <span class="text-color-1 mb-3 text-center text-md-left">TRABAJA CON NOSOTROS</span>
            <h2 class="text-color-2 mb-3 text-center text-md-left">Trabaja con nosotros en Unipar, nuestros empleados
              son los principales protagonistas</h2>
            <p class="text-color-2 mb-4 text-center text-md-left">Sostenibilidad, Protagonismo, Ética y Credibilidad,
              Respeto por las personas, Excelencia y Calidad para ser la primera opción del cliente son nuestros
              valores.
              <br>
              Somos inclusivos y respetamos la diversidad, trabajamos colaborativamente y fomentamos la innovación.
              Promovemos el desarrollo profesional y un ambiente sano y seguro. Nuestra gente es fundamental para
              nuestro crecimiento sostenible.
            </p>

            <div class="d-flex justify-content-center justify-content-md-start">
              <router-link to="/vagas/375953-trabaje-con-nosotros/inscricao"
                class="btn btn-color-1 rounded-pill py-2 px-5">
                INSCRIBITE
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row pt-5 mt-5" id="gptw">
      <div class="col-12 col-md-10 mx-auto">
        <div class="d-flex align-items-center flex-column flex-md-row pb-5">
          <img src="@/assets/images/selo-gptw-es.png" style="max-height: 250px" id="selo-gptw" />
          <div class="p-5" id="texto-gptw">
            <span class="text-color-2 text-center mb-2">SOMOS GPTW</span>
            <h1 class="text-color-2 text-center pb-3">SOMOS GPTW EN 2023!</h1>
            <p class="text-color-2 text-center">¡Nuevamente somos una de las Mejores Empresas para Trabajar!</p>
            <p class="text-color-2 text-center">¡Estamos muy felices de haber sido certificados nuevamente por Great
              Place To Work como una de las Mejores Empresas para Trabajar en Argentina en 2023!</p>
          </div>
        </div>
      </div>

      <div class="row pb-5">
        <img src="@/assets/images/banner-gptw.png" />
      </div>

      <div class="col-12 col-md-10 mx-auto">
        <div class="video-thumb" @click="modalVideoUrl = 'gptw.mp4'">
          <img src="@/assets/images/thumb-video-2.png" />
          <img src="@/assets/images/play.png" class="play">
        </div>
      </div>
    </div>

    <div class="row pt-5 " id="historia">
      <div class="col-12 col-md-10 mx-auto">
        <div class="box d-flex align-items-center flex-column flex-md-row mb-5">
          <div class="p-5">
            <span class="text-color-2 text-left mb-2">EXPERIENCIA EN EL MERCADO</span>
            <h1 class="text-color-1 text-left pb-3">54 años de evolución!</h1>
            <p class="text-color-2 text-left">A lo largo de nuestra historia, con todos los desafíos y logros, crecimos
              y nos hemos reinventado, pero nuestro ADN sigue siendo el mismo: una empresa líder que persigue la
              excelencia, el crecimiento sustentable y el trabajo en equipo que tiene como propósito ser confiable en
              todas nuestras relaciones.</p>
          </div>

          <img src="@/assets/images/historia.jpeg" style="height: 100%; object-fit: cover;" />
        </div>

        <div class="video-thumb" @click="modalVideoUrl = 'video3-es.mp4'">
          <img src="@/assets/images/thumb-video-3.png" />
          <img src="@/assets/images/play.png" class="play">
        </div>
      </div>
    </div>

    <div class="row pt-5 pb-5" id="fotos">
      <Slider mode="gallery" class="col-12 col-md-11 mx-auto banner">
        <div class="item">
          <img src="@/assets/images/gallery-1.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/gallery-2.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/gallery-3.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/gallery-4.png" />
        </div>
        <div class="item">
          <img src="@/assets/images/gallery-5.png" />
        </div>
      </Slider>
    </div>

    <div class="row mt-5">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-1 text-left mb-2 text-center text-md-left">DESCUBRE NUESTROS PROGRAMAS</span>
        <h1 class="text-color-2 text-left pb-3 text-center text-md-left">Programa de Desarrollo</h1>
        <p class="text-color-2 text-left mb-5 text-center text-md-left">Los programas de desarrollo son esenciales para
          la adaptación y el crecimiento continuo de una empresa en un entorno empresarial en constante evolución.</p>

        <div class="row justify-content-center">
          <div class="col-12 col-md-4 mb-5">
            <div class="box-programas">
              <h3>Programa de Desarrollo de Liderazgo Unipar</h3>
              <p>En Unipar nuestra gente es nuestra prioridad número 1. Desarrollamos este programa para prepararnos
                para el crecimiento empresarial, reforzar nuestra Cultura UNIPAR y ofrecer herramientas de gestión de
                personas.</p>
            </div>

            <a href="https://unipar.com/es/personas/" class="btn btn-color-1 btn-block px-5 py-2 rounded-pill"
              target="_blank">
              VER PROGRAMA
            </a>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-programas">
              <h3>Pasantía</h3>
              <p>El programa ofrece excelentes oportunidades para que tú, estudiante comprometido, aprendas y crezcas.
                Ven a ampliar tus horizontes en una empresa como la nuestra. ¡Ven a hacer la diferencia!</p>
            </div>

            <a href="https://unipar.com/es/programa-de-pasantias-unipar/"
              class="btn btn-color-1 btn-block px-5 py-2 rounded-pill" target="_blank">
              VER PROGRAMA
            </a>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-programas">
              <h3>Jóvenes Profesionales</h3>
              <p>Consiste en una jornada completa dentro de una empresa química líder en su segmento en Sudamérica. El
                programa es anual, y el período de inscripciones está abierto en el primer trimestre.</p>
            </div>

            <a href="https://unipar.com/es/personas/" class="btn btn-color-1 btn-block px-5 py-2 rounded-pill"
              target="_blank">
              VER PROGRAMA
            </a>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-programas">
              <h3>Academia <img src="@/assets/images/logo-unipar-2.png" :alt="'Logotipo ' + $store.state.websiteName"
                  :title="$store.state.websiteName" /></h3>
              <p>Nuestra Academia genera un valor sustentable para la empresa. Más que eso: permite más inversión en las
                personas, y más crecimiento.</p>
            </div>

            <a href="https://unipar.com/es/programa-academia-unipar-espanol/"
              class="btn btn-color-1 btn-block px-5 py-2 rounded-pill" target="_blank">
              VER PROGRAMA
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5 py-5" style="background-color: #F2F2F2;">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-1 text-left mb-2 text-center text-md-left">TRABAJA CON NOSOTROS</span>
        <h1 class="text-color-2 text-left pb-3 text-center text-md-left">Las certificaciones</h1>

        <div class="row justify-content-center pt-5">
          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>ISO 9001</h3>
              <hr />
              <p>Busca gerenciar con eficacia los distintos procesos integrados en la empresa, con el objetivo de
                aumentar la satisfacción del cliente por medio de la mejora continua y la garantía de conformidad con
                sus requisitos.</p>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>ISO 14001</h3>
              <hr />
              <p>Tiene el objetivo de garantizar la conformidad con las leyes ambientales aplicables e identificar,
                controlar y minimizar los aspectos e impactos de las actividades, productos y servicios de la empresa
                relacionados con el medio ambiente.</p>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>ISO 45001</h3>
              <hr />
              <p>Busca garantizar la conformidad con las legislaciones aplicables de seguridad y salud ocupacional e
                identificar, controlar y minimizar los peligros y riesgos de las actividades, productos y servicios de
                la empresa para preservar a las personas.</p>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>Actuación Responsable</h3>
              <hr />
              <p>Es un compromiso con la mejora continua del desempeño en salud, seguridad y medio ambiente, promoviendo
                la sustentabilidad y contribuyendo, de esa manera, a aumentar la calidad de vida de la sociedad.</p>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>HALAL</h3>
              <hr />
              <p>Es una certificación de índole religiosa que sigue los requisitos para garantizar alimentos permitidos
                para quienes profesan el islamismo. Productos o alimentos halal son aquellos que obedecen la ley
                islámica.</p>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-5">
            <div class="box-certificacao">
              <h3>KOSHER</h3>
              <hr />
              <p>Es una certificación de índole religiosa que sigue los requisitos para garantizar alimentos permitidos
                para quienes profesan el judaísmo. Productos o alimentos kosher son aquellos que obedecen la ley judía.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row my-5 py-5">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-1 text-center mb-2">¡Nuestras vacantes están abiertas!</span>
        <h1 class="text-color-2 text-center pb-3">El cuidado con las personas es una de las premisas centrales en la
          conducción de nuestros negocios</h1>
        <p class="text-color-2 text-center mb-5">Nuestras acciones nos conectan con nuestros objetivos de
          sostenibilidad. Por lo tanto, contamos con cada empleado para entregar resultados y generar valor para los
          clientes, accionistas, inversionistas, socios y el planeta.</p>

        <div class="d-flex justify-content-center">
          <router-link to="/vagas/375953-trabaje-con-nosotros/inscricao"
            class="btn btn-color-1 rounded-pill mx-2 px-5 py-3">
            INSCRIBITE
          </router-link>
        </div>
      </div>
    </div>

    <hr />

    <div class="row my-5 py-5" id="vagas">
      <div class="col-12 col-md-10 mx-auto">
        <span class="text-color-2 text-center mb-2">¡Vení a trabajar con nosotros!</span>
        <h1 class="text-color-1 text-center pb-3">VACANTES DISPONIBLES</h1>

        <Jobs :key="$route.fullPath" />
      </div>
    </div>

    <div class="row py-5 enderecos">
      <div class="col-12 col-md-8 mx-auto">
        <h1 class="text-color-2 text-center">DIRECCIONES UNIPAR ARGENTINA</h1>

        <hr class="my-5" />

        <div class="row">
          <div class="col-12 col-md-2"></div>
          <div class="col-12 col-md-4">
            <h3>BUENOS AIRES</h3>

            <p>
              Av. Juana Manso 555 7º D<br /><br />
              Puerto Madero - CABA<br /><br />
              C1107CBK<br /><br />
              Tel. <a href="tel:+541152839300">+54 (11) 5283-9300</a>
            </p>
          </div>

          <div class="col-12 col-md-4">
            <h3>FÁBRICA BAHÍA BLANCA</h3>

            <p>
              Av. Pte. Frondizi 2450<br /><br />
              Puerto Galván - Bahia Blanca<br /><br />
              B8101XAD<br /><br />
              Tel. <a href="tel:+540291459300">+54 (0291) 459-300</a>
            </p>
          </div>
          <div class="col-12 col-md-2"></div>
        </div>
      </div>
    </div>

    <div class="row py-5 enderecos" style="background-color: #F2F2F2;">
      <div class="col-12 col-md-8 mx-auto">
        <h1 class="text-color-2 text-center">DIRECCIONES UNIPAR BRASIL</h1>

        <hr class="my-5" />

        <div class="row">
          <div class="col-12 col-md-4">
            <h3>SÃO PAULO - SEDE</h3>

            <p>
              Avenida Presidente Juscelino
              Kubitschek, 1327 - 22º andar<br /><br />
              São Paulo - SP - Brasil<br /><br />
              CEP 04543-011<br /><br />
              Tel. <a href="tel:+551137044200">+55 (11) 3704-4200</a>
            </p>
          </div>

          <div class="col-12 col-md-4">
            <h3>FÁBRICA CUBATÃO</h3>

            <p>
              Rod. Cônego Domênico
              Rangoni (SP-055), KM 267,7<br /><br />
              Pista Leste s/nº<br /><br />
              Cubatão - SP - Brasil<br /><br />
              CEP 11573 901<br /><br />
              Tel. <a href="tel:+551333628000">+55 (13) 3362-8000</a>
            </p>
          </div>

          <div class="col-12 col-md-4">
            <h3>FÁBRICA SANTO ANDRÉ</h3>

            <p>
              Estrada de Ferro Santos Jundiaí KM 38<br /><br />
              Santo André - SP - Brasil<br /><br />
              CEP 09154-900<br /><br />
              Tel. <a href="tel:+5511344398822">+55 (11) 34439-8822</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "@/components/Slider.vue";
import Faq from "@/components/Faq.vue";
import Share from "@/components/jobs/Share.vue";
import Jobs from "@/components/jobs/Jobs.vue";

export default {
  name: "home",

  data() {
    return {
      modalVideoUrl: null
    };
  },

  components: {
    Slider,
    Faq,
    Share,
    Jobs,
  },

  mounted() {
  },

  methods: {
  },
};
</script>

<style lang="scss" scoped>
/deep/.banner {
  .banner-content {
    background: #F2F2F2;
    display: flex;
    width: 100%;

    @media (max-width: 980px) {
      flex-direction: column;
    }

    img {
      width: 50%;
      max-height: 500px;
      object-fit: cover;

      @media (max-width: 980px) {
        width: 100%;
      }
    }
  }

  .banner-text {
    flex-shrink: 0;
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0 150px;

    @media (max-width: 980px) {
      width: 100%;
      padding: 80px;
      align-items: center;
    }

    h1 {
      margin-bottom: 30px;
      text-align: left;
      font-size: 42px !important;
      line-height: 1.2 !important;

      @media (max-width: 980px) {
        text-align: center;
      }
    }
  }

  .tns-controls {
    position: absolute;
    left: 5%;
    right: 5%;
    /* height: 100%; */
    top: 50%;
    margin-top: -24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;

    @media (max-width: 600px) {
      /* height: auto; */
      /* top: 100%; */
    }

    button {
      width: 48px;
      height: 48px;
      border: none;
      background: none;
      padding: 0;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      &[data-controls="prev"] {
        background-image: url('../assets/images/arrow-left.svg');
      }

      &[data-controls="next"] {
        background-image: url('../assets/images/arrow-right.svg');
      }

      &[disabled] {
        opacity: 0.2;
      }

      @media (max-width: 600px) {
        width: 38px;
        height: 38px;
      }
    }
  }

  .tns-item.item {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    h1 {
      max-width: 820px;
      font-family: 'Inter', sans-serif;
      font-size: 36px;
      font-weight: 700;
      line-height: 42px;
      letter-spacing: -0.02em;
      /* text-align: center; */
      color: #000000;

      @media (max-width: 980px) {
        max-width: 400px;
      }

      @media (max-width: 600px) {
        max-width: 90vw;
        font-size: 28px;
      }

      img {
        display: inline-block;
        vertical-align: baseline;
      }
    }

    p {
      max-width: 820px;
      font-family: 'Inter', sans-serif;
      font-size: 24px;
      font-weight: 400;
      line-height: 46px;
      letter-spacing: 0em;
      text-align: center;

      @media (max-width: 980px) {
        max-width: 400px;
      }

      @media (max-width: 600px) {
        max-width: 90vw;
        font-size: 20px;
        line-height: 1.6;
      }
    }
  }
}

.video-thumb {
  width: 100%;
  height: 55vh;
  background: #999;
  border-radius: 32px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  img:not(.play) {
    position: absolute;
    inset: 0;
    object-fit: cover;
    max-width: none;
  }

  img.play {
    width: 80px;
    height: 80px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -40px;
    margin-top: -40px;
    z-index: 1;
  }
}

hr {
  border-color: #E1E1E1;
}

span {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  /* line-height: 24px; */
  letter-spacing: 0.03em;
  display: block;
}

h1 {
  font-family: Inter;
  font-size: 42px;
  font-weight: 700;
  /* line-height: 83px; */
  letter-spacing: 0em;
}

h2 {
  font-family: Inter;
  font-size: 42px;
  font-weight: 500;
  /* line-height: 62px; */
  letter-spacing: 0em;
}

p {
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  /* line-height: 24px; */
  letter-spacing: 0em;
}

.box {
  border-radius: 32px;
  background: #F2F2F2;
  overflow: hidden;

  img {
    max-width: 500px;
  }

  h1 {
    font-size: 38px;
  }
}

.modalVideoUrl {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;

  button {
    width: 45px;
    height: 45px;
    background-color: theme-color('color-1');
    position: absolute;
    left: 20px;
    top: 20px;
    border-radius: 50%;
    border: none;
  }

  .video {
    width: 90%;
    height: 100%;
    max-width: 800px;
    max-height: 500px;
    position: relative;
    background-color: theme-color('color-1');
    border-radius: 32px;
  }

  iframe,
  video {
    border-radius: inherit;
    width: 100%;
    height: 100%;
  }
}

.box-programas {
  background-color: #F2F2F2;
  padding: 50px 30px;
  border-radius: 32px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100% - 60px);

  h3 {
    font-family: Inter;
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: 0em;
    text-align: left;
    color: #22232B;

    img {
      height: 32px;
      vertical-align: middle;
    }
  }

  p {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
    color: #22232B;
  }
}

.box-certificacao {
  h3 {
    font-family: Inter;
    font-size: 32px;
    font-weight: 600;
    line-height: 42px;
    letter-spacing: 0em;
    text-align: center;
    color: #00B432;
  }

  hr {
    border-color: #00B432;
    margin: 15px auto;
    max-width: 100px;
  }

  p {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    color: #22232B;
  }
}

.enderecos {
  h1 {
    font-size: 30px;
  }

  hr {
    border-color: #00B432;
    margin: 15px auto;
    max-width: 200px;
  }

  h3 {
    font-family: Inter;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0em;
    color: #22232B;
  }

  p {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0em;
    text-align: left;
    color: #858585;

    a {
      color: inherit;
    }
  }
}


#trabalhe-conosco {
  background-color: #F2F2F2;

  @media (max-width: 980px) {
    background-color: #ffff;
  }
}


#gptw {
  #selo-gptw {
    @media (max-width: 980px) {
      order: 2;
    }
  }
}

/deep/ .depoimento-item {
  max-width: 70%;

  .img {
    width: 200px;
    height: 200px;
    flex-shrink: 0;
    flex-grow: 1;
    margin-right: 20px;
    display: flex;
    align-items: center;

    @media (max-width: 720px) {
      width: auto;
      height: auto;
      order: 2;
      margin-right: 0;
      margin-top: 20px;

      img {
        width: 120px;
        height: 120px;
        margin-right: 20px;
      }
    }
  }

  img {
    width: 200px;
    height: 200px;
    border-radius: 50%;
  }

  p {
    font-size: 14px !important;
    line-height: 1.4 !important;
    max-width: none !important;
  }
}

#vagas {
  h2 {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    padding: 30px 0 0 0;
  }

  p {
    text-align: center;
    font-size: 16px;
  }
}
</style>
